import './banner.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';
class ListItem extends Component {
  static propTypes = {
    banner: PropTypes.array,
  };

  // 统计模板入口点击量
  initStat = () => {
    const { banner } = this.props;
    sendStat(
      'RP_STORE',
      '作品详情页',
      '点击作品详情页的banner',
      Stat.ACTION_CLICK,
      {
        id: 'web_apppreview_detail_banner_click',
        bannerid: banner[0].bannerId,
      }
    );
  };

  render() {
    const { banner } = this.props;
    return (
      <div className="banner-container">
        {banner.length > 0 ? (
          <a
            href={banner[0].jumpUrl}
            target="{_blank}"
            onClick={this.initStat.bind(this)}>
            <img
              className="banner-image"
              src={banner[0].imageUrl}
              alt={banner[0].imageTitle}
            />
          </a>
        ) : null}
      </div>
    );
  }
}

export default ListItem;
